import React, { ChangeEvent } from "react";

import { Button, Container, Form, FormGroup, InputGroup } from "reactstrap";

interface Props {
  livestock?: string;
  setLivestock: (s: "cows" | "sheep") => void;
  submit?: Function;
}

export const SelectLivestockForm = ({
  livestock,
  setLivestock,
  submit,
}: Props) => {
  const onOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (["cows", "sheep"].includes(event.target.value))
      setLivestock(event.target.value as "cows" | "sheep");
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (!submit) return;
    event.preventDefault();
    submit();
  };

  return (
    <div className="pt-3">
      <h4>Choose your livestock</h4>
      <Container fluid>
        <Form onSubmit={handleSubmit}>
          <FormGroup className="d-flex gap-5">
            <InputGroup style={{ width: "initial" }}>
              <input
                type="radio"
                name="cows"
                value="cows"
                id="cows"
                checked={livestock === "cows"}
                onChange={onOptionChange}
              />
              <label htmlFor="cows" className="m-1 ms-2">
                Cattle herd
              </label>
            </InputGroup>
            <InputGroup style={{ width: "initial" }}>
              <input
                type="radio"
                name="sheep"
                value="sheep"
                id="sheep"
                checked={livestock === "sheep"}
                onChange={onOptionChange}
              />
              <label htmlFor="sheep" className="m-1 ms-2">
                Sheep flock
              </label>
            </InputGroup>
          </FormGroup>
          {submit && (
            <Button
              type="submit"
              color="primary"
              disabled={livestock === undefined}
            >
              Continue
            </Button>
          )}
        </Form>
      </Container>
    </div>
  );
};
